import type { PreviewPlugin, PreviewToolbarOptions } from '@open-file-viewer/core'
import { archivePlugin, officePlugin, pdfPlugin, textPlugin } from '@open-file-viewer/core'
import workerSrc from 'pdfjs-dist/build/pdf.worker.mjs?url'
// open-file-viewer 0.1.20 does not load the prerequisites for Scala and JSON5.
import 'prismjs'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-json'

export const fileViewerPlugins: PreviewPlugin[] = [
  pdfPlugin({ workerSrc }),
  officePlugin({ pdf: { workerSrc } }),
  archivePlugin(),
  textPlugin(),
]

interface FileViewerToolbarMessages {
  zoomOut: string
  zoomIn: string
  resetZoom: string
  fullscreen: string
}

export function createFileViewerToolbar(messages: FileViewerToolbarMessages): PreviewToolbarOptions {
  return {
    zoom: true,
    rotate: false,
    download: false,
    fullscreen: true,
    print: false,
    search: false,
    order: ['zoom-out', 'zoom-in', 'zoom-reset', 'fullscreen'],
    labels: {
      fullscreen: messages.fullscreen,
    },
    titles: {
      'zoom-out': messages.zoomOut,
      'zoom-in': messages.zoomIn,
      'zoom-reset': messages.resetZoom,
      'fullscreen': messages.fullscreen,
    },
  }
}

export const spreadsheetFileExtensions = new Set([
  'xlsx',
  'xls',
  'xlsm',
  'xlsb',
  'xlt',
  'xltx',
  'xltm',
  'csv',
  'tsv',
  'ods',
  'fods',
  'numbers',
  'et',
])

export const spreadsheetMimeTypes = new Set([
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroenabled.12',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  'application/vnd.ms-excel.template.macroenabled.12',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.spreadsheet-flat-xml',
  'application/vnd.apple.numbers',
  'text/csv',
  'text/tab-separated-values',
])
